var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"name":"Headers"}},[_c('div',{staticClass:"headers"},[_c('svg-icon',{attrs:{"icon-class":"four-squares","class-name":"log-img"}}),_c('div',{staticClass:"img-tle",on:{"click":function($event){return _vm.nextPagehandle()}}},[_vm._v(" < "+_vm._s(_vm.$t("myProduct"))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }